import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import tr from './locales/tr/translation.json';

const resources = {
  tr: { translation: tr },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    supportedLngs: ['tr'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
